// @flow
import { themeStyle } from '../colorPalettes'
import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const name = 'loviztv'

export const themeLoviztv: ThemeType = {
  name,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.light:
        return darkTheme
      case themeStyle.dark:
        return darkTheme
      default:
        return darkTheme
    }
  },
}
